import React, { useState } from 'react';
import { ProductCard } from './ProductCard';
import { CartNotification } from './CartNotification';
import { useCart } from '../context/CartContext';
import type { Product, ProductVariant } from '../types/product';

interface ProductDisplayProps {
  title: string;
  products: Product[];
  className?: string;
}

export function ProductDisplaySection({ title, products, className = '' }: ProductDisplayProps) {
  const { addItem } = useCart();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProduct, setNotificationProduct] = useState<{ name: string; image: string } | null>(null);

  if (!products || products.length === 0) {
    return null;
  }

  const handleAddToCart = (variant: ProductVariant) => {
    addItem({
      id: variant.id,
      name: variant.name,
      price: variant.discounted_price || variant.price,
      quantity: 1,
      image: variant.images[0],
      stock: variant.stock
    });

    setNotificationProduct({
      name: variant.name,
      image: variant.images[0]
    });
    setShowNotification(true);
  };

  return (
    <div className={className}>
      {showNotification && notificationProduct && (
        <CartNotification
          product={notificationProduct}
          isVisible={showNotification}
          onClose={() => setShowNotification(false)}
        />
      )}

      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-12">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onAddToCart={handleAddToCart}
          />
        ))}
      </div>
    </div>
  );
}
